// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* drop the .page selector when this migrates to staff */
.page--jwjvc {
  width: 100%;
  padding: 1rem;
}

.toggleGrid--KKYWA {
  display: grid;
  gap: var(--space-m);
  grid-template-columns: 1fr 1fr;
  margin-top: var(--space-m);
}
`, "",{"version":3,"sources":["webpack://./src/institution_settings/CustomSettingPage.module.css"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;AAC5B","sourcesContent":["/* drop the .page selector when this migrates to staff */\n.page {\n  width: 100%;\n  padding: 1rem;\n}\n\n.toggleGrid {\n  display: grid;\n  gap: var(--space-m);\n  grid-template-columns: 1fr 1fr;\n  margin-top: var(--space-m);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `page--jwjvc`,
	"toggleGrid": `toggleGrid--KKYWA`
};
export default ___CSS_LOADER_EXPORT___;
